module.exports = __webpack_public_path__ + "static/media/FAQs.a0fcc1a5.svg";